import React, { useState } from 'react';
import FeatureRequestModal from '../components/FeatureRequestModal.merged';
import { Link } from 'react-router-dom';
import ROUTES from '../routes.json';
import { normalizeRoute } from '../utils/routeHelpers';

const FeatureRequestPage = ({ backendUrl }) => {
  const [open, setOpen] = useState(true);

  return (
    <div className="feature-request-page" style={{padding:20}}>
      <h1 className="page-title">Suggest a Feature</h1>
      <div className="page-content" style={{ marginTop: 12, color: '#6b7280' }}>
        <p>
          Use this page to tell us which features would make OneAI more useful for your workflows. Feature requests help prioritize work and bring real-user ideas into product planning. Describe the problem you want solved and any examples of how you'd use the feature.
        </p>
        <p>
          We review requests and triage them based on impact, feasibility, and alignment with our roadmap. Please include context like expected outcomes, sample inputs, and the primary audience — these details help our product and engineering teams evaluate requests and estimate effort more accurately. Even small details about how a feature would fit into your workflow make a difference when we prioritize work.
        </p>
        <p>
          After you submit a request, our team reviews it and may ask clarifying questions. Not every request will be implemented immediately, but we track demand and revisit high-impact items. We also share updates for major feature requests and may include selected items in beta releases for user feedback.
        </p>
        <ul style={{ marginTop: 8 }}>
          <li>Describe the problem and the desired outcome in practical terms.</li>
          <li>Share example inputs or screenshots to illustrate the need.</li>
          <li>We evaluate requests based on impact, feasibility, and user demand.</li>
        </ul>
        <p style={{ marginTop: 12 }}>
          When submitting, include any constraints or compliance requirements that matter to your team (for example, data residency or accessibility needs). This helps us assess whether a request needs special handling or an enterprise-level agreement. Sharing how often the feature would be used and who benefits can also shift prioritization.
        </p>

        <p>
          We seek to be transparent about feature progress: while not every request will be implemented, high-impact requests are tracked and sometimes included in beta releases for feedback. If your request is part of a larger workflow or integration, note this in the description so product managers can weigh integration complexity and potential partners.
        </p>
      </div>

      {/* Render the modal inline — it will call onClose to dismiss */}
      {open && (
        <FeatureRequestModal
          backendUrl={backendUrl}
          onClose={() => setOpen(false)}
          onSent={() => setOpen(false)}
        />
      )}

      {!open && (
        <div>
          <button className="btn" onClick={() => setOpen(true)}>Suggest another feature</button>
        </div>
      )}

      <div style={{ marginTop: 20 }}>
        <h4>Explore more</h4>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <Link to={normalizeRoute(ROUTES.humanizer.path)} className="btn ghost">Try the Humanizer</Link>
          <Link to={normalizeRoute(ROUTES.blog.path)} className="btn ghost">Visit our Blog</Link>
          <Link to={normalizeRoute(ROUTES.contact.path)} className="btn ghost">Contact Us</Link>
        </div>
      </div>
    </div>
  );
};

export default FeatureRequestPage;
